import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteKey from './key';
import DefaultHeaderEmpty from '../components/DefaultHeaderEmpty';
import SchoolCandidatePaymentPage from '../pages/payment/SchoolCandidatePaymentPage';
import SchoolCandidateAppealPaymentPage from '../pages/payment/SchoolCandidateAppealPaymentPage';
import Receipt from '../pages/resit/Receipt';

const { error: errorRoute } = RouteKey.child;
const { schoolCandidatePayment, schoolCandidateAppealPayment } = RouteKey.payment.child;
const { receipt } = schoolCandidatePayment.child;

const SchoolCandidatePaymentRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/${schoolCandidatePayment.route}`} exact>
        <DefaultHeaderEmpty />
        <SchoolCandidatePaymentPage />
      </Route>

      <Route path={`${path}/${schoolCandidateAppealPayment.route}`} exact>
        <DefaultHeaderEmpty />
        <SchoolCandidateAppealPaymentPage />
      </Route>
      <Route exact path={`${path}/:examRegistrationType/:uuid/${receipt.route}`}>
        <DefaultHeaderEmpty />
        <Receipt />
      </Route>
      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};
export default SchoolCandidatePaymentRoute;
